import { render, staticRenderFns } from "./Asthma.vue?vue&type=template&id=70630364&lang=pug&"
import script from "./Asthma.vue?vue&type=script&lang=js&"
export * from "./Asthma.vue?vue&type=script&lang=js&"
import style0 from "./Asthma.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports